import { render, staticRenderFns } from "./AuthorizeStage.vue?vue&type=template&id=678abf1d&scoped=true"
import script from "./AuthorizeStage.vue?vue&type=script&lang=js"
export * from "./AuthorizeStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678abf1d",
  null
  
)

export default component.exports